import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { InvoicesContainer } from "@/screens/Accounting/subfeatures/Invoices"
import { invoicesSearchParamsSchema } from "@/screens/Accounting/subfeatures/Invoices/schemas"

export const Route = createFileRoute("/app/accounting/_layout/accounts-payable")({
  validateSearch: invoicesSearchParamsSchema,
  search: {
    middlewares: [retainSearchParams(["query"])],
  },
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.ACCOUNTS_PAYABLE_VIEW, PermissionActionType.ACCOUNTS_PAYABLE_MAINTENANCE]}
    >
      <InvoicesContainer />
    </PermissionContentWrapper>
  ),
})
